const HomePage = () => {
    return (
        <>
            <h1>THIS IS A TEST PAGE</h1>
            <h1>THIS IS A TEST PAGE</h1>
        </>
    );
}

export default HomePage